<key-map-toolbar-routing
    class="flex-1 d-flex"
    (onSetMarker)="addMarker($event)"
    (onMarkersClear)="clearMultipleMarkers($event)"
    (onRoutesUpdated)="updateRoutes($event)"
    (onRoutesClear)="clearRoutes($event)"
    (onClose)="onClose()"
>
</key-map-toolbar-routing>
